import { casaBool, casaID, casaIgual, casaTexto } from "@/lib/filtros/texto";
import type { Fuente } from "@/lib/fuentes";

/** CLAVES_FUENTES son los parámetros que admite el listado de fuentes de energía (#247). */
export const CLAVES_FUENTES = ["equipo", "tipo", "activo", "q"] as const;

/** FiltrosFuentes es el objeto de filtros del listado de fuentes tal como viaja en la URL. */
export type FiltrosFuentes = Partial<Record<(typeof CLAVES_FUENTES)[number], string>>;

/**
 * filtrarFuentes aplica los filtros en el navegador (modo sin red, D2). Debe dar el MISMO
 * resultado que el SQL del servidor: ver la tabla de casos compartida en
 * backend/internal/factory/filtros_integration_test.go (TestFiltrosFuentesHTTP).
 */
export function filtrarFuentes(filas: Fuente[], filtros: FiltrosFuentes): Fuente[] {
  return filas.filter(
    (f) =>
      casaID(filtros.equipo, f.id_equipo) &&
      casaIgual(filtros.tipo, f.tipo) &&
      casaBool(filtros.activo, f.activo) &&
      casaTexto(filtros.q, f.codigo_fuente, f.nombre_fuente),
  );
}
